import * as React from "react";
import { Routes, Route } from 'react-router-dom';
import { VerifiedRegistration,Header } from "container/registration";
import ManageProfileMC from "container/mapCenter/ManageProfileMC";
import { FAQViews } from "container/loginPage";

const RegistrationLayout = () => {

    return (
        
        <Routes>
            <Route path="verified" element={<VerifiedRegistration />} />
            <Route element={<Header />}>
            <Route path="mapCenter/:portalkey/:id" element={<ManageProfileMC />} />
            <Route path="/faqView" element={<FAQViews hasHeader={false} />} />
            </Route>
        </Routes>
        
    );
}

export default RegistrationLayout;